import { motion } from 'framer-motion'
import x from '../../assets/icons/close.svg'
import React, { useEffect, useRef } from 'react'

const ViewOrderReport = ({ active, close, orderReport }) => {
  const popupref = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) {
        close()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [popupref, close])

  useEffect(() => {
    if (active) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [active])
  return (
    <motion.div
      className=" fixed inset-0 bg-overlay/30 w-screen  z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className=" w-1/3 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <div className="w-full">
          <div className=" w-full px-8 py-5 flex flex-col gap-8 ">
            <div className="flex border-b-[1px] pb-4 justify-between border-b-darkBlue w-full">
              <div>Order Report</div>
              <img src={x} onClick={close} className=" cursor-pointer" alt="" />
            </div>
            <div className="  flex flex-col w-full gap-2 justify-center">
              <div className=" text-start text-darkBlue">
                Client Name : {orderReport.client_name}
              </div>
              <div className=" text-start text-darkBlue">
                Order Id : {orderReport.order_id}
              </div>
              <div className=" text-start text-darkBlue">
                Order Status : {orderReport.status}
              </div>
              <div className=" text-start text-darkBlue">Order Items :</div>
              <div className=" w-full h-60 overflow-y-auto flex flex-col gap-5 p-1">
                {orderReport.orderItems.map((item, index) => (
                  <div className=" shadow rounded p-3 flex gap-5 justify-start items-stretch">
                    <img
                      src={item.package.image}
                      alt={item.package.title}
                      className=" w-20 aspect-square rounded "
                    />
                    <div className=" flex flex-col justify-center items-start">
                      <div className=" text-blueButton">
                        {item.package.title}
                      </div>
                      <div className=" text-blueButton">
                        Quantity :{item.package.count}
                      </div>
                    </div>
                    <div className=" flex flex-col justify-center items-start">
                      <div className=" text-blueButton">
                        Normal Price :
                        {item.package.client_offers ||
                          item.package.price_client}
                      </div>
                      <div className=" text-blueButton">
                        WholeSale Price :{' '}
                        {item.package.pos_offers ||
                          item.package.price_pos_client}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  )
}

export default ViewOrderReport
